export class SlotStatus
{
    private _msg:string;

    private constructor(msg:string)
    {
        this._msg = msg;
    }

    public static readonly ReadyToEval = new SlotStatus('ƒ READY');
    public static readonly Loading = new SlotStatus('Loading');
    public static readonly Streaming = new SlotStatus('Streaming');

    public isEqualTo(status:SlotStatus):boolean
    {
        return status && this._msg && this._msg.toLowerCase() === status._msg.toLowerCase();
    }

    public toString():string
    {
        return this._msg;
    }

    // public static fromFSlotStatus(aSlotStatus:FSlotStatus):SlotStatus
    // {
    //     switch( aSlotStatus )
    //     {
    //         case FSlotStatus.ReadyToEval:
    //             return SlotStatus.ReadyToEval;
    //         case FSlotStatus.Loading:
    //             return SlotStatus.Loading;
    //         case FSlotStatus.Streaming:
    //             return SlotStatus.Streaming;
    //     }
    //
    //     return null;
    // }

    // public static toFSlotStatus(slotStatus:SlotStatus):FSlotStatus
    // {
    //     if( SlotStatus.ReadyToEval.isEqualTo(slotStatus) )
    //         return FSlotStatus.ReadyToEval;
    //     else if( SlotStatus.Loading.isEqualTo(slotStatus) )
    //         return FSlotStatus.Loading;
    //     else if( SlotStatus.Streaming.isEqualTo(slotStatus) )
    //         return FSlotStatus.Streaming;
    //     else
    //         return FSlotStatus.Default;
    // }
}
